export default function Provide(name, provider) {
  var cachedProvider = typeof provider === 'function' ? null : provider;

  return function (context) {
    context[name] = cachedProvider = cachedProvider || provider(context);

    if (context.debugger) {
      context.debugger.wrapProvider(name);
    }

    return context;
  };
}
//# sourceMappingURL=Provide.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/cerebral/es/Provide.js
// module id = 536
// module chunks = 1